export const optimizarImagenWebp = (file, { maxHeight = 1080, quality = 0.82 } = {}) => (
    new Promise((resolve, reject) => {
        if (!file || !file.type?.startsWith('image/')) {
            resolve(file);
            return;
        }

        const image = new Image();
        const objectUrl = URL.createObjectURL(file);

        image.onload = () => {
            try {
                const scale = image.height > maxHeight ? maxHeight / image.height : 1;
                const width = Math.max(1, Math.round(image.width * scale));
                const height = Math.max(1, Math.round(image.height * scale));

                const canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;

                const context = canvas.getContext('2d');
                context.drawImage(image, 0, 0, width, height);

                canvas.toBlob((blob) => {
                    URL.revokeObjectURL(objectUrl);

                    if (!blob) {
                        reject(new Error('No se pudo optimizar la imagen.'));
                        return;
                    }

                    const nombreBase = file.name.replace(/\.[^.]+$/, '') || 'imagen';
                    resolve(new File([blob], `${nombreBase}.webp`, { type: 'image/webp' }));
                }, 'image/webp', quality);
            } catch (error) {
                URL.revokeObjectURL(objectUrl);
                reject(error);
            }
        };

        image.onerror = () => {
            URL.revokeObjectURL(objectUrl);
            reject(new Error('No se pudo leer la imagen.'));
        };

        image.src = objectUrl;
    })
);
